import { Injectable } from '@angular/core'
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, LogLevel } from '@azure/msal-browser'

@Injectable({ providedIn: 'root' })
export class DynamicMsalService {
  private msalInstance?: IPublicClientApplication

  async init(clientId: string, authority: string): Promise<IPublicClientApplication> {
    // msal-browser v3 requires a PublicClientApplication to be initialized (async) before use.
    // createPublicClientApplication() does the construction and initialize() call together and
    // returns an already-initialized instance, instead of `new PublicClientApplication(...)`
    // followed by a separate `.initialize()` call.
    this.msalInstance = await PublicClientApplication.createPublicClientApplication({
      auth: {
        clientId,
        authority,
        redirectUri: '/',
        postLogoutRedirectUri: '/'
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        allowNativeBroker: false,
        loggerOptions: {
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false
        }
      }
    })

    return this.msalInstance
  }

  getInstance(): IPublicClientApplication {
    if (!this.msalInstance) {
      throw new Error('MSAL instance not initialized')
    }
    return this.msalInstance
  }
}
